import { useMutation } from '@tanstack/react-query';

import { useGameSlug } from '@pkg/hooks';

import { type ResourceId } from '@app/client/common/structs';
import { callUpdateCompetitionWinners, type UpdateWinner } from '@app/client/resources/admin/fantasy';
interface MutationParams extends UpdateWinner {
    winnerId: ResourceId;
}
export function useAssignCompetitionWinners() {
    const gameSlug = useGameSlug();

    return useMutation({
        mutationFn: ({ user_id, team_id, winnerId, reason }: MutationParams) =>
            callUpdateCompetitionWinners({ slug: gameSlug, winnerId, value: { user_id, team_id, reason } }),
        onError: (error) => {
            if (error) {
                alert(error);
            }
        },
    });
}
